export {
  CollectionPageContextProvider,
  CollectionPageContextConsumer,
  useCollectionPageContext,
  collectionPageContext,
} from '@wix/bex-core/react';
